var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"parkDetails"},[_c('div',{staticClass:"park-title-box"},[_c('h3',{staticClass:"fs-25"},[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.tip)),_c('span',{staticClass:"grayTColor ml-10"},[_vm._v(_vm._s(_vm.tipTime))])])]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"park-main"},[_c('img',{attrs:{"src":require("../../assets/img/user.png"),"alt":"内容"}})])
}]

export { render, staticRenderFns }